import { InjectionToken } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

export interface WidgetRouteSnapshot {
    getActiveRoute: () => ActivatedRouteSnapshot | undefined;
}

export const WIDGET_ROUTE_SNAPSHOT_TOKEN = new InjectionToken<WidgetRouteSnapshot>('WIDGET_ROUTE_SNAPSHOT_TOKEN', {
    providedIn: 'root',
    factory: () => ({ getActiveRoute: () => undefined }),
});
